import { render, staticRenderFns } from "./dingyue.vue?vue&type=template&id=67c7c504&scoped=true&"
import script from "./dingyue.vue?vue&type=script&lang=js&"
export * from "./dingyue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7c504",
  null
  
)

export default component.exports